import { SimpleCommand } from "./../../../../commanding/SimpleCommand";
import { ExternalInterface } from "@goodgamestudios/createjs-utilities";
import { EnvGlobalsHandler } from "../../../EnvGlobalsHandler";
import { BasicModel } from "../../../model/BasicModel";

const JS_GGS_TRACK_EVENT_FUNCTION: string = "ggsTrackEvent";
export class GGSTrackEventCommand extends SimpleCommand {
    public execute(commandVars: string): void {
        if (commandVars) {
            const GNIP = {userid: `${EnvGlobalsHandler.globals.gameId}-${EnvGlobalsHandler.globals.networkId}-${BasicModel.instanceProxy.selectedInstanceVO.instanceId}-${BasicModel.userData.playerID}`};
            if (ExternalInterface.available) {
                ExternalInterface.call(JS_GGS_TRACK_EVENT_FUNCTION, commandVars, GNIP);
            }
        }
    }
}

